import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import type { DeleteProductRequestDto } from "../../dtos/delete-product-request-dto";
import { ProductService } from "../../services/product-service";

export type UseDeleteProductDraftMutationParams = {
  options?: UseMutationOptions<
    { success: boolean },
    unknown,
    DeleteProductRequestDto
  >;
};

export const useDeleteProductDraftMutation = ({
  options
}: UseDeleteProductDraftMutationParams = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      return await ProductService.deleteProductDraft({
        payload: {
          productId: payload.productId
        }
      });
    },
    onSuccess: async (...args) => {
      options?.onSuccess?.(...args);
    },
    ...options
  });
};
